import CopyOutlined from '@ant-design/icons/CopyOutlined';
import DeleteOutlined from '@ant-design/icons/DeleteOutlined';
import EditOutlined from '@ant-design/icons/EditOutlined';
import { Grid, IconButton, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { compareAsc, format, getDate } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { DateDetail } from 'interfaces/event';

import * as S from './styles';

interface EventDatesProps {
  fields: DateDetail[];
  onDelete: (arrayId: string, id?: string) => void;
  onDuplicate: (eventDate: DateDetail) => void;
  onEdit: (eventDate: DateDetail) => void;
}

const EventDates = ({ fields, onDelete, onDuplicate, onEdit }: EventDatesProps) => {
  const orderFields = (): DateDetail[] => {
    const orderFields = [...fields];

    orderFields.sort((a, b) => compareAsc(a.date, b.date));

    return orderFields;
  };

  return (
    <Grid item>
      <TableContainer component={Paper}>
        <S.CustomizedTable>
          <TableHead>
            <TableRow>
              <TableCell align='left'>Dia</TableCell>
              <TableCell align='right'>Início</TableCell>
              <TableCell align='left'>Término</TableCell>
              <TableCell align='right'>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orderFields().map(field => {
              const dayOfWeek = format(field.date, 'EEEE', { locale: ptBR });
              const day = getDate(field.date);
              const month = format(field.date, 'LLLL', { locale: ptBR });

              return (
                <TableRow key={field.id}>
                  <TableCell align='left'>
                    {dayOfWeek}, {day} de {month}
                  </TableCell>
                  <TableCell align='right'>{format(new Date(field.start_time), 'HH:mm')}</TableCell>
                  <TableCell align='left'>{format(new Date(field.end_time), 'HH:mm')}</TableCell>
                  <TableCell align='right'>
                    <IconButton onClick={() => onEdit(field)}>
                      <EditOutlined style={{ color: '#000000' }} />
                    </IconButton>
                    <IconButton>
                      <CopyOutlined onClick={() => onDuplicate(field)} style={{ color: '#000000' }} />
                    </IconButton>
                    <IconButton>
                      <DeleteOutlined onClick={() => onDelete(field.arrayId, field.id)} style={{ color: '#000000' }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </S.CustomizedTable>
      </TableContainer>
    </Grid>
  );
};

export default EventDates;
